import { SaveAlt, Search } from "@material-ui/icons";
import { Box, Fab, Grid, TextField, Tooltip } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import Select from "components/select/Select";
import {
  ALL_OPTION,
  LIST_ANSWERED_DURATION,
  LIST_INBOUND_CALL_STATUS,
} from "constant";
import { useFormik } from "formik";
import { useSelectExtension } from "hooks/select/useSelectExtension";
import { useGetListAgent } from "service/query/agent.query";
import { useGetListContactCenter } from "service/query/common.query";
import { useGetListPhoneNumber } from "service/query/phone-number.query";
import {
  getDateRangePickerFieldProps,
  getSelectFieldProps,
  getTextFieldProps,
} from "ultis/form";

const InboundCallFilter = ({ onSubmit, onExport, isDisabledExport }) => {
  const defaultFrom = new Date();
  defaultFrom.setHours(0, 0, 0, 0);
  const defaultTo = new Date(defaultFrom);
  defaultTo.setHours(23, 59, 59, 999);

  const formik = useFormik({
    initialValues: {
      fromNumber: "",
      contactCode: ALL_OPTION.value,
      toNumber: ["1900545481"],
      agent: ALL_OPTION.value,
      status: ALL_OPTION.value,
      extensionId: "",
      ivrExtension: ALL_OPTION.value,
      answeredDuration: ALL_OPTION.value,
      dateRange: [defaultFrom, defaultTo],
    },
    onSubmit,
  });

  const { data: listContactCenter } = useGetListContactCenter();
  const { data: listPhoneNumber } = useGetListPhoneNumber();
  const { data: listAgent } = useGetListAgent({ query: "all" });
  const extensionSelect = useSelectExtension();

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField
              {...getTextFieldProps(formik, "fromNumber")}
              label="Số điện thoại gọi"
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "contactCode")}
              label="Đơn vị tiếp nhận"
              options={listContactCenter?.map((item) => ({
                value: item.code,
                label: item.name,
              }))}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "toNumber")}
              label="Số điện thoại nhận"
              options={listPhoneNumber?.map((item) => ({
                value: item.id,
                label: item.id,
              }))}
              isMulti
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "agent")}
              label="Tài khoản"
              options={listAgent?.map((item) => ({
                value: item.id,
                label: item.user
                  ? `${item.user.username} - ${item.user.fullname}`
                  : "",
              }))}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "status")}
              label="Trạng thái"
              options={LIST_INBOUND_CALL_STATUS}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "extensionId")}
              label="Máy lẻ"
              options={extensionSelect.options}
              onScroll={extensionSelect.handleScroll}
              onSearch={extensionSelect.handleSearch}
              loading={extensionSelect.loading}
              filterOption={false}
              allowClear
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "ivrExtension")}
              label="Trạng thái"
              options={[
                { value: "0", label: "0" },
                { value: "1", label: "1" },
                { value: "2", label: "2" },
                { value: "3", label: "3" },
              ]}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "answeredDuration")}
              label="Thời lượng trả lời"
              options={LIST_ANSWERED_DURATION}
              showAllOption
            />
          </Grid>

          <Grid item xs={6}>
            <DateRangePicker
              {...getDateRangePickerFieldProps(formik, "dateRange")}
              isTime
              startDateLabel="Thời gian gọi từ"
              endDateLabel="Thời gian gọi đến"
            />
          </Grid>

          <Grid item xs={3}>
            <Tooltip title="Tìm kiếm" disableFocusListener>
              <Fab color="primary" aria-label="Search" type="submit">
                <Search />
              </Fab>
            </Tooltip>
            <Tooltip title="Tải báo cáo" disableFocusListener>
              <Fab
                color="primary"
                sx={{ ml: 1 }}
                aria-label="Search"
                onClick={onExport}
                disabled={isDisabledExport}>
                <SaveAlt />
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default InboundCallFilter;
